export const loginForm = 'login';
export const signUpForm = 'signup';
export const forgotPasswordForm = 'forgot-password';



// WEBPACK FOOTER //
// ./src/utils/formNames.js